import { useRef, useState } from 'react';
import { motion, useMotionValue, useSpring, useAnimation } from 'framer-motion';
import { useProximityOffset } from '../hooks/useProximityOffset';
import { useIdleGlitch } from '../hooks/useIdleGlitch';

const MASK_SRC = '/zato-mask.png';
const PROXIMITY_RADIUS = 240;

export function InstallationMask() {
  const wrapRef = useRef(null);
  const [isNear, setIsNear] = useState(false);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const springX = useSpring(x, { stiffness: 120, damping: 14 });
  const springY = useSpring(y, { stiffness: 120, damping: 14 });
  const controls = useAnimation();

  useProximityOffset(wrapRef, x, y, setIsNear, PROXIMITY_RADIUS);
  useIdleGlitch(controls);

  const handleTap = () => {
    if (!window.matchMedia('(pointer: coarse)').matches) return;
    controls.start({
      scale: [1, 1.08, 0.98, 1],
      rotate: [0, -3, 2, 0],
      filter: ['brightness(1)', 'brightness(1.5)', 'brightness(1)', 'brightness(1)'],
      transition: { duration: 0.45 },
    });
  };

  return (
    <div
      ref={wrapRef}
      className="installation-mask-wrap"
      data-testid="zato-interactive-mask"
      onClick={handleTap}
    >
      <motion.div
        className="installation-mask-aura"
        animate={{ opacity: isNear ? 0.6 : 0.28 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      />
      <motion.div style={{ x: springX, y: springY }} animate={controls} initial={{ scale: 1, rotate: 0 }}>
        <motion.img
          src={MASK_SRC}
          alt="ZATO mask"
          className="installation-mask-img"
          animate={{
            y: [0, -5, 1, -3, 0],
            rotate: [0, 0.6, -0.4, 0.3, 0],
            scale: [1, 1.006, 0.996, 1.002, 1],
          }}
          transition={{ duration: 13, repeat: Infinity, ease: 'easeInOut' }}
        />
      </motion.div>
    </div>
  );
}
